webpackJsonp([36883904255065],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logo = __webpack_require__(40);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'head' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement('img', { src: logo, alt: 'DAN EV - Dienst am N\xE4chsten', className: 'logo' }),
	        _react2.default.createElement(
	          'span',
	          {
	            id: 'global-slogan',
	            'data-editable': 'simpletext',
	            className: 'slogan',
	            'data-global': 'data-global'
	          },
	          'Nachbarschaftshilfe',
	          _react2.default.createElement('br', null),
	          'von Mensch zu Mensch'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hotline' },
	          _react2.default.createElement(
	            'strong',
	            {
	              id: 'global-fragen',
	              'data-editable': 'simpletext',
	              'data-global': 'data-global'
	            },
	            'Sie haben Fragen?'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            {
	              id: 'global-phone',
	              'data-editable': 'simpletext',
	              'data-global': 'data-global'
	            },
	            '0174/3444893',
	            _react2.default.createElement('br', null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'nav' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/home' },
	              'Startseite'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/geschichte' },
	              '\xDCber Uns'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'active' },
	            _react2.default.createElement(
	              'a',
	              { href: '/dienstleistungen', className: 'active' },
	              'Dienstleistungen'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/sie-wollen-helfen' },
	              'Sie wollen helfen?'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/mitglieder' },
	              'Mitglieder'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/kontakt' },
	              'Kontakt'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          { id: 'headline', 'data-editable': 'simpletext', className: 'mb1' },
	          'Dienstleistungsangebote'
	        ),
	        _react2.default.createElement(
	          'p',
	          { id: 'subheadline', 'data-editable': 'simpletext' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Wir st\xE4rken und unterst\xFCtzen Sie in Ihrem Alltag zu Hause.\xA0'
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'p',
	          { id: 'content', 'data-editable': 'text' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Im Haushalt:\xA0'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          ' Einkaufen, Essen zubereiten, W\xE4scheversorgung.....\xA0',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Bei einfachen Pflegearbeiten:\xA0'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          ' Entlastung pflegender Angeh\xF6riger, Aufstehen und Ankleiden, Unterst\xFCtzung der Pflegedienste....',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Im sozialen Bereich:'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          ' Besuchs- und Fahrdienste, Begleitung zum Arzt oder Veranstaltungen sowie Beh\xF6rdeng\xE4nge....',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Kinder- und Familienhilfe:\xA0'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          ' Betreuung von Kindern, Unterst\xFCtzung der Eltern.....\xA0',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Beratung:'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          ' Vermittlung von Hilfsangeboten, Ausf\xFCllen von Antr\xE4gen und Formularen.....\xA0',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Hilfe rund ums Haus:'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          ' Wir helfen bei kleineren Problemen.....\xA0',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Gespr\xE4che:'
	            )
	          ),
	          '\xA0',
	          _react2.default.createElement('br', null),
	          ' Wir nehmen uns Zeit f\xFCr Sie und h\xF6ren Ihnen zu.\xA0'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'p',
	          { id: 'ending', 'data-editable': 'text' },
	          'Wir helfen da, wo Hilfe gebraucht wird: schnell, unkompliziert, bedarfsgerecht und bezahlbar.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Durch die \xDCbernahme der Tr\xE4gerschaft der Nachbarschaftshilfe Dienst am N\xE4chsten werden diese Angebote seit 1. Januar 2020 von der Keppler-Stiftung, Katholische Sozialstation Ulm verantwortet.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          ' F\xFCr Fragen stehen wir Ihnen gerne zur Seite'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-dienstleistungen-js-ee70804f302f2e2581a0.js